import { createSlice } from "@reduxjs/toolkit";

// CONSTANTS ------------------------------------------------------------------

const INITIAL_STATE = {
  show: false,
  id: "",
};

// SLICE ----------------------------------------------------------------------

export const modalSlice = createSlice({
  name: "modal",
  initialState: INITIAL_STATE,
  reducers: {
    showModal: (state, action) => {
      Object.entries(INITIAL_STATE).forEach(([key, value]) => {
        state[key] = value;
      });
      state.show = true;
      if (typeof action.payload === typeof {}) {
        Object.entries(action.payload).forEach(([key, value]) => {
          state[key] = value;
        });
      }
    },
    updateModal: (state, action) => {
      if (typeof action.payload === typeof {}) {
        Object.entries(action.payload).forEach(([key, value]) => {
          state[key] = value;
        });
      }
    },
    hideModal: (state, _action) => {
      state.show = false;
    },
  },
});

// ACTIONS --------------------------------------------------------------------

export const { showModal, hideModal, updateModal } = modalSlice.actions;

// SELECTORS ------------------------------------------------------------------

export const modalSelector = (state) => state.modal;

// REDUCER --------------------------------------------------------------------

export default modalSlice.reducer;
